import { Feather } from '@expo/vector-icons';
import * as Clipboard from 'expo-clipboard';
import { router, useLocalSearchParams } from 'expo-router';
import { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { FlatList } from 'react-native-gesture-handler';
import { Divider } from 'react-native-paper';
import { SafeAreaView } from 'react-native-safe-area-context';
import Toast from 'react-native-toast-message';

import BrandedButton from '@/components/buttons/BrandedButton';
import Text from '@/components/Text';
import GiftShowSummaryCard from '@/components/trbShow/GiftShowSummaryCard';
import { GiftShowsData } from '@/lib/validations/GiftShowSchema';
import { i18n } from '@/utils/i18n';
import { safeJsonParse } from '@/utils/jsonParse';

const GiftSummary = () => {
  const { giftFormData } = useLocalSearchParams<{
    giftFormData: string;
  }>();
  const [parsedGiftFormData, setParsedGiftFormData] = useState<GiftShowsData>();

  useEffect(() => {
    setParsedGiftFormData(safeJsonParse<GiftShowsData>(giftFormData ?? ''));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [giftFormData]);

  const handleCopyUrl = async () => {
    const message = i18n.t('giftShows.gifted_copy_url');
    await Clipboard.setStringAsync(message);
    Toast.show({
      type: 'success',
      text1: i18n.t('mix.copied.title'),
      text2: i18n.t('mix.copied.link'),
      position: 'bottom',
      visibilityTime: 2000
    });
  };

  return (
    <SafeAreaView edges={['bottom']} style={[styles.flexOne, styles.mainContainer]}>
      <View style={styles.content}>
        <View>
          <Text style={[styles.whiteText, styles.headerSubtitle]}>{i18n.t('giftShows.summary_subtitle')}</Text>

          <View style={styles.giftedPersonContainer}>
            {parsedGiftFormData?.gifts && (
              <FlatList
                data={parsedGiftFormData.gifts}
                keyExtractor={(item) => item.phone}
                showsVerticalScrollIndicator={false}
                contentContainerStyle={styles.giftGap}
                ItemSeparatorComponent={() => <Divider />}
                renderItem={({ item }) => (
                  <GiftShowSummaryCard firstName={item.firstName} lastName={item.lastName} phone={item.phone} />
                )}
              />
            )}
            <BrandedButton style={styles.shareButton} onPress={handleCopyUrl}>
              <View style={styles.shareButtonContent}>
                <Feather name="copy" size={24} color="white" style={styles.icon} />
                <Text fontWeight="700" style={styles.shareLabel}>
                  {i18n.t('mix.copy_url')}
                </Text>
              </View>
            </BrandedButton>
          </View>
        </View>

        <BrandedButton textStyles={styles.buttonText} onPress={() => router.back()} style={styles.button}>
          {i18n.t('mix.done')}
        </BrandedButton>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  flexOne: {
    flex: 1
  },

  mainContainer: {
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'black',
    paddingVertical: 10
  },

  content: {
    flex: 1,
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },

  headerSubtitle: {
    justifyContent: 'center',
    textAlign: 'center'
  },

  whiteText: {
    color: 'white'
  },

  giftedPersonContainer: {
    marginVertical: 10,
    width: '100%'
  },

  divider: {
    width: '100%',
    marginTop: 10,
    backgroundColor: 'white'
  },

  giftGap: {
    gap: 5
  },

  button: {
    width: '100%',
    backgroundColor: 'green',
    marginBottom: 10
  },

  buttonText: {
    color: 'black'
  },

  icon: {
    padding: 8
  },

  shareButton: {
    backgroundColor: 'gray',
    marginVertical: 15
  },

  shareLabel: {
    color: 'white'
  },

  shareButtonContent: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 2,
    padding: 5
  }
});

export default GiftSummary;
